import React from 'react'
import './Navbar.css';
import logo from '../asset/logo2.jpg';
import logo2 from '../asset/zenito-removebg-preview.png';
import { useState } from 'react';

import { Link } from 'react-router-dom';


const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <>
        <div className='Navigationbar'>
            <div className='Nav'>
                <img src={logo2} />
                <div className='Nav-content Darkerr'>
                    <h1>Zenito Ventures</h1>
                    <p> Trusted Name in overseas Education</p>

                </div>


            </div>

            
        </div>
        <div className="Second-nav">
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      <div className={`Navs ${menuOpen ? "active" : ""}`}>
        <ul>
          <li>
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
            <Link to="/whychooseus" onClick={() => setMenuOpen(false)}>Why Choose Us</Link>
            <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
          </li>
        </ul>
      </div>
    </div>
        </>
        
    )
}

export default Navbar
